var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgIcnMenuTasksNotactive(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 16.311,
    height: 14.311,
    viewBox: "0 0 16.311 14.311",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icn-menu-tasks-notactive",
    transform: "translate(1.061 1.061)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "icn-menu-tasks-notactive-2",
    "data-name": "icn-menu-tasks-notactive",
    opacity: 0.467
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_2435",
    "data-name": "Path 2435",
    d: "M3.5,5.362,4.818,6.655,7.015,4.5",
    transform: "translate(-3.5 -4.5)",
    fill: "none",
    stroke: "#36383e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2436",
    "data-name": "Path 2436",
    d: "M3.5,11.362l1.318,1.293,2.2-2.155",
    transform: "translate(-3.5 -5.328)",
    fill: "none",
    stroke: "#36383e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2437",
    "data-name": "Path 2437",
    d: "M3.5,17.362l1.318,1.293,2.2-2.155",
    transform: "translate(-3.5 -6.155)",
    fill: "none",
    stroke: "#36383e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1008",
    "data-name": "Line 1008",
    x2: 8,
    transform: "translate(6.5 1.5)",
    fill: "none",
    stroke: "#36383e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1009",
    "data-name": "Line 1009",
    x2: 8,
    transform: "translate(6.5 6.5)",
    fill: "none",
    stroke: "#36383e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line_1010",
    "data-name": "Line 1010",
    x2: 8,
    transform: "translate(6.5 11.5)",
    fill: "none",
    stroke: "#36383e",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 1.5
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcnMenuTasksNotactive);
export default __webpack_public_path__ + "static/media/icn-menu-tasks-notactive.70702fbaf7fe64f31dcf7c9a4ec064f7.svg";
export { ForwardRef as ReactComponent };